import { Box, BoxProps, Flex, IconButton, Text } from '@chakra-ui/react';
import Tooltip from '~/components/Tooltip';
import { InfoNoBorderIcon } from '~/components/icons';

import { THighlightCard } from './MediaPackDetailHighlightCard.types';
import {
  MediaPackDetailHighlightCardMultiValues,
  MediaPackDetailHighlightCardSingleValues,
} from './components';

type Props = BoxProps & THighlightCard;

export const MediaPackDetailHighlightCard: React.FC<Props> = ({
  description,
  metricKey,
  title,
  transformValue,
  value,
  values,
  lastUpdated,
  ...props
}) => {
  return (
    <Box
      minHeight={{ base: '92px', md: '160px' }}
      padding={4}
      borderWidth="1px"
      borderColor="primary.200"
      borderRadius={6}
      {...props}
    >
      <Flex position="relative" alignItems="center" marginBottom={4}>
        <Text
          color="neutral.600"
          fontSize="md"
          fontWeight={500}
          textTransform="uppercase"
          noOfLines={1}
        >
          {title}
        </Text>

        {!!description && (
          <Tooltip
            fontSize="md"
            fontWeight="medium"
            isTouchFriendly
            label={description}
            marginLeft="auto"
            placement="bottom"
          >
            <IconButton
              _hover={{
                color: 'secondary.500',
              }}
              variant="link"
              aria-label=""
              color="primary.500"
              icon={<InfoNoBorderIcon boxSize="16px" />}
            />
          </Tooltip>
        )}
      </Flex>

      {value !== null && value !== undefined && (
        <MediaPackDetailHighlightCardSingleValues
          value={value}
          lastUpdated={lastUpdated}
          transformValue={transformValue}
          metricKey={metricKey}
        />
      )}

      <MediaPackDetailHighlightCardMultiValues
        values={values ?? []}
        lastUpdated={lastUpdated}
        transformValue={transformValue}
      />
    </Box>
  );
};
